/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_BAN_MOVEMENTS_ITEM = {
  id: 'banks_movements',
  screenId: 'fin-ban-movements',
  label: 'Movimientos',
  description: 'Saldos y movimientos por cuenta bancaria autorizada.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Consultás el saldo y el historial de movimientos de cada cuenta bancaria. También podés registrar traspasos entre cuentas o entre banco y caja, y ver si cada línea ya fue conciliada con un extracto.',
      },
      {
        title: 'Antes de empezar',
        paragraphs: [
          'Necesitás tener al menos una entidad bancaria y una cuenta bancaria cargadas (menú «Bancos» y «Cuentas bancarias»).',
          'El selector de cuenta muestra solo las cuentas a las que tu usuario tiene permiso de lectura. Si no ves ninguna, pedí acceso en Configuración → Usuarios.',
        ],
      },
      {
        title: 'Paso 1 — Elegir cuenta y fechas',
        fields: [
          {
            label: 'Cuenta bancaria',
            description: 'Lista desplegable con la descripción de cada cuenta (por ejemplo «Banco Galicia CC pesos»).',
          },
          {
            label: 'Fecha desde / Fecha hasta',
            description: 'Rango a consultar. Por defecto suele mostrarse la última semana hasta hoy. Al cambiar una fecha se recarga la lista.',
          },
          {
            label: 'Saldo',
            description: 'Saldo de la cuenta al cierre del período, según el sistema.',
          },
        ],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Columnas: Fecha, Descripción, Referencia, Usuario, Monto, Saldo y Conciliado (Sí / No).',
          'Tocá una fila (salvo la papelera) para ver el detalle del movimiento: comprobante de cobro, pago o traspaso que lo generó.',
          'Si la columna Conciliado dice No, en esa fila aparece un ícono de papelera para eliminar el movimiento (solo los no conciliados).',
          'Podés exportar la lista con el botón de descarga de la grilla.',
        ],
      },
      {
        title: 'Paso 3 — Agregar un traspaso',
        intro: 'El botón + abre «Agregar Movimiento». Campos:',
        fields: [
          { label: 'Fecha', description: 'Día del movimiento.' },
          {
            label: 'Tipo de movimiento',
            description:
              'Según permisos: por ejemplo de banco a banco, de banco a caja o de caja a banco. El sistema carga las opciones disponibles para tu usuario.',
          },
          {
            label: 'Destino',
            description: 'La otra cuenta bancaria o la caja involucrada en el traspaso.',
          },
          {
            label: 'Monto',
            description:
              'Importe a transferir. Si origen y destino tienen monedas distintas, completá el monto en la cuenta origen y el equivalente en la cuenta destino.',
          },
        ],
        paragraphs: [
          'Al confirmar se registran los movimientos en ambas cuentas (o en banco y caja) y la lista se actualiza.',
        ],
      },
      {
        title: 'Eliminar un movimiento',
        paragraphs: [
          'Solo podés eliminar líneas que aún no están conciliadas. El sistema identifica si el movimiento viene de un traspaso interno, un cobro o un pago y revierte la operación correspondiente.',
        ],
      },
    ],
  },
}
